

export function loadingHtml() {
  return `
      <div class="vinbird-loader">
        <div class="loader"></div>
      </div>
    `;
}

export function hideLoading() {
  $('.vinbird-loader').remove();
}
